import Timezones from "common/core/form/timezone/timezones";
import { unsupportedTimezone } from "errors/form";

import createValidation from "./util";

export const validateTimezone = createValidation(
  ({ value }) => Timezones.includes(value),
  unsupportedTimezone,
);
